export function getDefaultBranchSpecification(defaultBranch?: string | null) {
  return defaultBranch == null
    ? ''
    : defaultBranch.startsWith('refs/') || defaultBranch.startsWith('+')
      ? defaultBranch
      : `refs/heads/(${defaultBranch})`
}
